import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { Message } from 'primereact/message';
import TimelineImage from '../../../assets/images/course_application/timeline-thankyou.png'

const ThankYou = () => {
  const [hackerRankLink, setHackerRankLink] = useState('');
  const [hackerRankError, setHackerRankError] = useState('');

  const fetchHackerRankLink = () => {  
    fetch('/api/current_user/create_hackerrank_invite', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.hackerrank_link) {
        setHackerRankLink(data.hackerrank_link);
      } else {
        setHackerRankError(data.error);
      }
    })
    .catch(error => {
      setHackerRankError(error);
    });
  };

  useEffect(() => {
    fetchHackerRankLink();
  }, []);

  return (
    <>
      <img className="d-flex mx-auto mb-4" src={TimelineImage} alt="timeline with a current step titled Problem Solving Assessment" />
      <h3>Thanks for your interest in launching your career with LaunchCode!</h3>
      <h5>Hey, here's the next step!</h5>
      <p>There are three steps to LaunchCode’s application process and you must complete all three in order to be considered for enrollment. </p>

      <p>What's next? The second step of the application is completing a HackerRank assessment, which includes 10 questions to assess basic math skills and your ability to problem-solve. <a href="https://blog.launchcode.org/master-your-application-problem-solving" target="_blank">Here are some tips for success!</a></p>

      <p>Once you complete your HackerRank assessment, you’ll receive an email with instructions for the third and final step of our application process - a recorded video interview.</p>

      <p>Important Note: You have up to 14 days to complete both items. The below link is unique to your application, so please do not share it with anyone! </p>

      <p>Good luck - you got this!</p>

      {hackerRankError ? (
        <Message severity="error" text={ hackerRankError } />
      ) : !hackerRankLink ? (
        <p className="error">Loading your HackerRank link...</p>
      ) : (
        <Button
          variant='primary'
          onClick={() => window.open(hackerRankLink, '_blank')}
        >
          Start HackerRank Assessment
        </Button>
      )}
    </>
  )
};

export default ThankYou;
